var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightArrowPagi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 0C19.1274 0 24.5 5.37258 24.5 12C24.5 18.6274 19.1274 24 12.5 24C5.87258 24 0.5 18.6274 0.5 12C0.5 5.37258 5.87258 0 12.5 0Z",
    fill: "#F5F6FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7929 7.29289C10.4024 7.68342 10.4024 8.31658 10.7929 8.70711L14.0858 12L10.7929 15.2929C10.4024 15.6834 10.4024 16.3166 10.7929 16.7071C11.1834 17.0976 11.8166 17.0976 12.2071 16.7071L16.2071 12.7071C16.5976 12.3166 16.5976 11.6834 16.2071 11.2929L12.2071 7.29289C11.8166 6.90237 11.1834 6.90237 10.7929 7.29289Z",
    fill: "#8A92A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowPagi);
export default __webpack_public_path__ + "static/media/rightArrowPagi.eddacdde5244754f1af441954ccfc2c2.svg";
export { ForwardRef as ReactComponent };